export default "__VITE_ASSET__801d7ae2__"